<!-- eslint-disable vue/no-unused-vars -->
<template>
    <div v-if="modelValue" class="action-filter-area">
        <div class="container">
            <div class="d-flex justify-content-between align-items-center sm-flex-column">
                <div class="d-flex align-items-center" style="gap: 10px">
                    <button class="btn btn-secondary btn-sm" @click="visibleSavedFiltersModal = !visibleSavedFiltersModal">
                        {{ $t('views.inventory.chooseSavedFilter') }}
                    </button>
                    <button v-if="selectedFilterCard.id && ![-1, -2, -3].includes(selectedFilterCard.id)" type="button" class="btn bg-white primary-hover btn-sm" @click="setApplyFilter(true)">
                        <span
                            >{{ $t('views.inventory.savedCurrentFilter') }} <strong>({{ selectedFilterCard.filter_name }})</strong></span
                        >
                    </button>
                    <button class="btn bg-white primary-hover btn-sm" @click="visibleNewFilter = true">
                        <span>{{ $t('views.inventory.addNewFilter') }}</span>
                    </button>
                </div>
                <div class="d-flex align-items-center" style="gap: 10px">
                    <button v-if="![-1, -2, -3].includes(selectedFilterCard.id)" class="btn bg-white primary-hover btn-sm" @click="handleReset">{{ $t('views.inventory.clearAll') }}</button>
                    <button v-if="![-1, -2, -3].includes(selectedFilterCard.id)" class="btn btn-primary btn-sm" @click="setApplyFilter(false)">{{ $t('views.inventory.applyFilter') }}</button>
                    <button class="btn btn-secondary btn-sm" style="background-color: #a5b0be; border: 1px solid #a5b0be" @click="closeModal">
                        <i><i class="fa-solid fa-times" style="font-size: 18px"></i></i>
                    </button>
                </div>
            </div>
            <!-- <div class="action-filter-area__alert">
                {{ $t('views.inventory.alertMessage') }}
            </div> -->
            <div class="action-filter-area__inputs">
                <div class="d-flex align-items-center justify-content-between" style="padding: 16px 40px 0px 40px; border-bottom: 0.6px solid #e7eaf3; padding-bottom: 13px">
                    <span style="font-weight: 500; font-size: 15px; line-height: 21px">{{ $t('views.inventory.filtersText') }}</span>
                    <select v-model="filterOptions['operator']" class="form-select form-select-sm" style="width: 85px">
                        <option value="and" selected>{{ $t('views.inventory.and') }}</option>
                        <option value="or">{{ $t('views.inventory.or') }}</option>
                    </select>
                </div>
                <div class="row">
                    <div v-for="(item, index) in rangeData" :key="index" class="col-lg-4">
                        <div v-if="filterOptions[item[0]] && filterOptions[item[0]].hasOwnProperty('min')" :class="index === 0 || index === 1 || index === 2 ? 'filter-padding-1' : 'filter-padding-2'">
                            <label style="font-size: 14px; font-weight: 400; line-height: 21px; margin-bottom: 10px; color: #00203f">
                                {{ $t(`views.inventory.filters.${item[0]}.${$route.name === 'orders' && item[0] === 'productCostRange' ? 'ordersLabel' : 'label'}`) }}
                                <InfoTooltip v-if="$t(`views.inventory.filters.${item[0]}.tooltip`)" class="text-primary" :opacity="true" :content="$t(`views.inventory.filters.${item[0]}.tooltip`)"></InfoTooltip>
                            </label>
                            <div class="input-group mb-3">
                                <input v-model="filterOptions[item[0]].min" type="number" :placeholder="item[0] === 'dailySalesQuantityRange' ? $t(`views.inventory.quantity`) : 'Min.'" class="sm-input form-control" />
                                <span class="input-group-text" style="background-color: #fff !important">{{ showCurrenySymbol(item[0]) }}</span>
                                <input v-model="filterOptions[item[0]].max" type="number" :placeholder="item[0] === 'dailySalesQuantityRange' ? $t(`views.inventory.day`) : 'Max.'" class="sm-input form-control" />
                                <span class="input-group-text" style="background-color: #fff !important">{{ showCurrenySymbol(item[0]) }}</span>
                            </div>
                        </div>
                        <div class="filter-padding-2" v-else-if="item[0] === 'orderStatus'">
                            <label style="font-size: 14px; font-weight: 400; line-height: 21px; margin-bottom: 10px; color: #00203f">
                                {{ $t(`views.inventory.filters.orderStatus.label`) }}
                            </label>
                            <div class="input-group mb-3" style="width: 100% !important">
                                <multiselect
                                    style="width: 100% !important"
                                    :show-labels="false"
                                    v-model="selectedOrderStatuses"
                                    track-by="value"
                                    label="label"
                                    :searchable="true"
                                    :multiple="true"
                                    :placeholder="$t('views.inventory.filters.orderStatus.label')"
                                    :options="orderStatuses"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    ><template #selection="{ values, _search, isOpen }">
                                        <span class="multiselect__single" v-if="values.length" v-show="!isOpen"
                                            >{{ values[values.length - 1].label }}<template v-if="values.length > 1">, +{{ values.length - 1 }} {{ $t('common.status_count') }}</template></span
                                        >
                                    </template>
                                    <template v-slot:option="{ option }">
                                        <div class="option__desc d-flex justify-content-between" style="width: 100%; margin-left: 7px">
                                            <span class="option__title">{{ option.label }}</span>
                                            <span v-if="isHasValueInSelected('orderStatus', option.value)"><i class="bi-check-lg text-primary"></i></span>
                                        </div>
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="filter-padding-2" v-else-if="item[0] === 'returnType'">
                            <label style="font-size: 14px; font-weight: 400; line-height: 21px; margin-bottom: 10px; color: #00203f">
                                {{ $t(`views.inventory.filters.returnType.label`) }}
                            </label>
                            <div class="input-group mb-3" style="width: 100% !important">
                                <multiselect
                                    style="width: 100% !important"
                                    :show-labels="false"
                                    v-model="selectedReturnTypes"
                                    track-by="value"
                                    label="label"
                                    :searchable="true"
                                    :multiple="true"
                                    :placeholder="$t('views.inventory.filters.returnType.label')"
                                    :options="returnTypes"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    ><template #selection="{ values, _search, isOpen }">
                                        <span class="multiselect__single" v-if="values.length" v-show="!isOpen"
                                            >{{ values[values.length - 1].label }}<template v-if="values.length > 1">, +{{ values.length - 1 }} {{ $t('common.status_count') }}</template></span
                                        >
                                    </template>
                                    <template v-slot:option="{ option }">
                                        <div class="option__desc d-flex justify-content-between" style="width: 100%; margin-left: 7px">
                                            <span class="option__title">{{ option.label }}</span>
                                            <span v-if="isHasValueInSelected('returnStatus', option.value)"><i class="bi-check-lg text-primary"></i></span>
                                        </div>
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                        <div v-else-if="item[0] === 'category'" style="padding: 46px 40px 10px">
                            <label class="d-flex align-items-center" style="font-size: 14px; font-weight: 400; line-height: 21px; margin-bottom: 10px; color: #00203f">
                                <select v-model="filterOptions[item[0]]" class="form-select form-select-sm" style="color: #00203f">
                                    <option :value="null" selected disabled>{{ $t(`views.inventory.filters.${item[0]}.label`) }}</option>
                                    <option v-for="item in categories" :key="item.id" :value="item.category" :selected="item.category == filterOptions[item[0]]">{{ item.category }}</option>
                                </select>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <template v-for="(item, index) in Object.entries(filterOptions).filter((item) => (item[0] !== 'operator' && !filterOptions[item[0]]) || (filterOptions[item[0]] && typeof filterOptions[item[0]] === 'boolean'))" :key="index">
                        <div v-if="item[0] !== 'category'" class="col-lg-4">
                            <div style="padding: 0 40px 10px 40px">
                                <label style="font-size: 14px; font-weight: 400; line-height: 21px; margin-bottom: 10px; color: #00203f">
                                    <input v-model="filterOptions[item[0]]" type="checkbox" class="sm-input form-check-input" style="margin-right: 8px" checked />
                                    {{ $t(`views.inventory.filters.${item[0]}.label`) }}
                                </label>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <NewFilter v-model="visibleNewFilter" />
            <SavedFilters v-model="visibleSavedFiltersModal" />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { countryInfo } from '@/utils/helper'
import InfoTooltip from '@/components/Variations/InfoTooltip.vue'
import NewFilter from './modals/NewFilter.vue'
import SavedFilters from './modals/SavedFilters.vue'
import Multiselect from 'vue-multiselect'

const countries = countryInfo()

export default {
    name: 'InventoryFilters',
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'inventory',
        },
    },
    components: { InfoTooltip, NewFilter, SavedFilters, Multiselect },
    data() {
        return {
            countries,
            visibleNewFilter: false,
            visibleSavedFiltersModal: false,
            selectedOrderStatuses: [],
            selectedReturnTypes: [],
            refundInputs: false,
        }
    },
    computed: {
        ...mapGetters('market', ['currentMarket']),
        ...mapState('inventory', ['categories', 'selectedFilterCard', 'filterOptionsClone']),
        returnTypes() {
            return [
                {
                    label: this.$t('views.orders.returnTypes.DEFECTIVE'),
                    value: 'DEFECTIVE',
                },
                {
                    label: this.$t('views.orders.returnTypes.SELLABLE'),
                    value: 'SELLABLE',
                },
                {
                    label: this.$t('views.orders.returnTypes.CUSTOMER_DAMAGED'),
                    value: 'CUSTOMER_DAMAGED',
                },
                {
                    label: this.$t('views.orders.returnTypes.CARRIER_DAMAGED'),
                    value: 'CARRIER_DAMAGED',
                },
            ]
        },
        orderStatuses() {
            return [
                {
                    label: this.$t('views.orders.statuses.Refunded'),
                    value: 'Refunded',
                },
                {
                    label: this.$t('views.orders.statuses.Pending'),
                    value: 'Pending',
                },
                {
                    label: this.$t('views.orders.statuses.Unshipped'),
                    value: 'Unshipped',
                },
                {
                    label: this.$t('views.orders.statuses.PartiallyShipped'),
                    value: 'PartiallyShipped',
                },
                {
                    label: this.$t('views.orders.statuses.Shipped'),
                    value: 'Shipped',
                },
                {
                    label: this.$t('views.orders.statuses.Canceled'),
                    value: 'Canceled',
                },
                {
                    label: this.$t('views.orders.statuses.Unfulfillable'),
                    value: 'Unfulfillable',
                },
                {
                    label: this.$t('views.orders.statuses.InvoiceUncorfirmed'),
                    value: 'InvoiceUncorfirmed',
                },
                {
                    label: this.$t('views.orders.statuses.PendingAvailability'),
                    value: 'PendingAvailability',
                },
            ].sort((a, b) => a.label.localeCompare(b.label))
        },
        filterOptions: {
            get() {
                const hiddenFields = [
                    'minimumProfitAmountRange',
                    'myPriceDifferenceWithLowestSeller',
                    'myPriceDifferenceWithBuyBoxSeller',
                    'myProfitDifferenceWithLowestSeller',
                    'myProfitDifferenceWithBuyBoxSeller',
                    'dailySalesQuantityRange',
                    'numberOfVariations',
                    'salesRankRange',
                    'duplicateProduct',
                    'restrictedBrand',
                    'noSuitableSeller',
                    'restrictedProductList',
                    'category',
                    'restrictedBrandList',
                    'generalNumberOfVendors',
                    'pieceRangeToFitInTheParcel',
                    'productScoreRange',
                    'productStockNumberRange',
                    'totalSalesQuantityRange',
                    'noVariation',
                    'returnCount',
                    'productsWhichIAmSoleSeller',
                ]
                const hiddenOrderProductFields = [
                    'minimumProfitAmountRange',
                    'myPriceDifferenceWithLowestSeller',
                    'myPriceDifferenceWithBuyBoxSeller',
                    'myProfitDifferenceWithLowestSeller',
                    'myProfitDifferenceWithBuyBoxSeller',
                    'dailySalesQuantityRange',
                    'numberOfVariations',
                    'salesRankRange',
                    'duplicateProduct',
                    'restrictedBrand',
                    'noSuitableSeller',
                    'restrictedProductList',
                    'category',
                    'restrictedBrandList',
                    'orderStatus',
                    'generalNumberOfVendors',
                    'pieceRangeToFitInTheParcel',
                    'productScoreRange',
                    'productStockNumberRange',
                    'totalSalesQuantityRange',
                    'noVariation',
                    'returnType',
                    'lossOrders',
                    'replacementOrders',
                    'productsWhichIAmSoleSeller',
                ]

                const hiddenInventoryFields = ['orderStatus', 'replacementOrders', 'lossOrders', 'returnType', 'resellable', 'quantityOrder', 'returnCount']

                const filterOptions = this.$store.state.inventory.filterOptions
                if (this.$route.name === 'orders') {
                    return Object.keys(filterOptions).reduce((acc, key) => {
                        if (!hiddenFields.includes(key)) {
                            acc[key] = filterOptions[key]
                        }
                        return acc
                    }, {})
                }
                if (this.$route.name === 'orders-products') {
                    return Object.keys(filterOptions).reduce((acc, key) => {
                        if (!hiddenOrderProductFields.includes(key)) {
                            acc[key] = filterOptions[key]
                        }
                        return acc
                    }, {})
                }
                return Object.keys(filterOptions).reduce((acc, key) => {
                    if (!hiddenInventoryFields.includes(key)) {
                        acc[key] = filterOptions[key]
                    }
                    return acc
                }, {})
            },
            set(value) {
                Object.keys(value).forEach((key) => {
                    this.SET_FILTER_OPTIONS({ key, value: value[key] })
                })
            },
        },
        rangeData() {
            let range = {}
            for (const key in this.filterOptions) {
                const value = this.filterOptions[key]
                // eslint-disable-next-line no-prototype-builtins
                if ((value && typeof value === 'object' && value.hasOwnProperty('min')) || ['category', 'orderStatus', 'returnType'].includes(key)) {
                    range[key] = value
                }
            }
            return Object.entries(range)
        },
    },
    created() {
        this.getCategories()
        if (!this.deepEqual(this.filterOptions, this.filterOptionsClone)) {
            this.getFilters()
        }
    },
    unmounted() {
        this.SET_RESET_FILTER_OPTIONS()
    },
    methods: {
        ...mapActions('inventory', ['applyFilter', 'getCategories', 'getFilters']),
        ...mapMutations({
            SET_FILTER_OPTIONS: 'inventory/SET_FILTER_OPTIONS',
            SET_RESET_FILTER_OPTIONS: 'inventory/SET_RESET_FILTER_OPTIONS',
            SET_FILTER_PARAMS: 'inventory/SET_FILTER_PARAMS',
            SET_FILTER_PARAMS_ORDERS: 'orders/SET_FILTER_PARAMS',
        }),
        handleReset() {
            this.SET_RESET_FILTER_OPTIONS()
            this.selectedOrderStatuses = []
        },
        closeModal() {
            this.$emit('update:modelValue', false)
        },
        getCurrency(short) {
            if (countries[short]) {
                return countries[short].symbol + ' '
            }
            return short
        },
        getSymbol(short) {
            return countries[short].symbol
        },
        showCurrenySymbol(key) {
            const hashKeys = [
                'primeNumberOfSellers',
                'generalNumberOfVendors',
                'pieceRangeToFitInTheParcel',
                'productScoreRange',
                'dailySalesQuantityRange',
                'totalSalesQuantityRange',
                'productStockNumberRange',
                'salesRankRange',
                'quantityOrder',
                'returnCount',
            ]

            const percentageKeys = ['myPriceDifferenceWithLowestSeller', 'profitRateRange', 'myPriceDifferenceWithBuyBoxSeller']

            if (hashKeys.includes(key)) {
                return '#'
            }

            if (percentageKeys.includes(key)) {
                return '%'
            }

            return this.getCurrency(this.currentMarket.short)
        },
        setApplyFilter(isUpdate = false) {
            let filterParams = {}
            if (this.$route.name === 'orders' || this.$route.name === 'orders-products') {
                this.SET_FILTER_PARAMS_ORDERS({ key: 'page', value: 1 })
                filterParams = this.$store.state.orders.filterParams
            } else {
                this.SET_FILTER_PARAMS({ key: 'page', value: 1 })
                filterParams = this.$store.state.inventory.filterParams
            }
            const { search, filter_id, sortBy, ...params } = filterParams
            this.applyFilter({ payload: { filter_id: this.selectedFilterCard.id, options: this.filterOptions }, params })
                .then((data) => {
                    this.$emit('handleApply', data)
                    this.$emit('update:modelValue', false)
                    this.$toast.success(this.$t(`views.inventory.toast.${isUpdate ? 'update' : 'create'}.success`))
                })
                .catch((error) => {
                    console.log(error)
                    this.$toast.error(this.$t(`views.inventory.toast.${isUpdate ? 'update' : 'create'}.error`))
                })
        },
        deepEqual(obj1, obj2) {
            if (obj1 === obj2) return true
            if (obj1 === null || obj2 === null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
                return false
            }
            let keys1 = Object.keys(obj1)
            let keys2 = Object.keys(obj2)
            if (keys1.length !== keys2.length) {
                return false
            }
            for (let key of keys1) {
                if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
                    return false
                }
            }
            return true
        },
        isHasValueInSelected(type, value) {
            if (type === 'returnStatus') {
                return this.selectedReturnTypes.some((item) => item.value === value)
            }
            if (type === 'orderStatus') {
                return this.selectedOrderStatuses.find((item) => item.value === value)
            }
            return null
        },
    },
    watch: {
        selectedOrderStatuses: {
            handler(value) {
                // sort by value asc
                this.filterOptions.orderStatus = value.map((item) => item.value)

                if (value.length > 0 && value.some((item) => item.value === 'Refunded')) {
                    this.refundInputs = true
                }
            },
            deep: true,
        },
        selectedReturnTypes: {
            handler(value) {
                // sort by value asc
                this.filterOptions.returnType = value.map((item) => item.value)
            },
            deep: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.action-filter-area {
    padding: 16px 0;
    border-width: 1px;
    border-style: solid;
    border-color: #e7eaf3b2;
    background-color: #eff2f7;
    margin-bottom: 16px;

    &__alert {
        background-color: #f5ca9926;
        background: linear-gradient(0deg, rgba(245, 202, 153, 0.15), rgba(245, 202, 153, 0.15)), #ffffff;
        color: var((--inventory-primary));
        padding: 13px;
        border-radius: 8px;
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
    }

    &__inputs {
        background-color: #fff;
        border-radius: 8px;
        margin-top: 20px;
    }
}
.filter-padding {
    &-1 {
        padding: 20px 40px 10px 40px;
    }
    &-2 {
        padding: 0 40px 10px 40px;
    }
}
.primary-hover {
    &[disabled] {
        opacity: 0.5;
    }
    &:hover {
        background-color: #677788 !important;
        color: #fff;
    }
}
label {
    height: 25px;
}
input[type='checkbox']:not(:checked) {
    border: 1px solid #677788;
}
.offset-custom {
    margin-right: 66.66666667%;
}
</style>
